import { useStaticQuery, graphql } from "gatsby"
export const useBuildDate = () => {
  const { currentBuildDate } = useStaticQuery(
    graphql`
      query {
        currentBuildDate {
          currentDate
        }
      }
    `
  )
  return currentBuildDate.currentDate
}